/** Inline brand-mark SVGs — Lucide dropped brand icons, so we ship our own. */

const PATHS = {
	linkedin:
		"M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13ZM7.12 20.45H3.55V9h3.57v11.45ZM22.22 0H1.77C.8 0 0 .78 0 1.75v20.5C0 23.2.8 24 1.77 24h20.45c.98 0 1.78-.8 1.78-1.75V1.75C24 .78 23.2 0 22.22 0Z",
	facebook:
		"M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.7 4.53-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07Z",
	instagram:
		"M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16Zm0 1.62c-3.15 0-3.5.01-4.74.07-.91.04-1.4.19-1.73.32-.43.17-.74.37-1.07.69-.32.33-.52.64-.69 1.07-.13.33-.28.82-.32 1.73-.06 1.24-.07 1.59-.07 4.74s.01 3.5.07 4.74c.04.91.19 1.4.32 1.73.17.43.37.74.69 1.07.33.32.64.52 1.07.69.33.13.82.28 1.73.32 1.24.06 1.59.07 4.74.07s3.5-.01 4.74-.07c.91-.04 1.4-.19 1.73-.32.43-.17.74-.37 1.07-.69.32-.33.52-.64.69-1.07.13-.33.28-.82.32-1.73.06-1.24.07-1.59.07-4.74s-.01-3.5-.07-4.74c-.04-.91-.19-1.4-.32-1.73a2.88 2.88 0 0 0-.69-1.07 2.88 2.88 0 0 0-1.07-.69c-.33-.13-.82-.28-1.73-.32-1.24-.06-1.59-.07-4.74-.07Zm0 2.76a5.46 5.46 0 1 1 0 10.92 5.46 5.46 0 0 1 0-10.92Zm0 9a3.54 3.54 0 1 0 0-7.08 3.54 3.54 0 0 0 0 7.08Zm5.68-9.23a1.28 1.28 0 1 1-2.55 0 1.28 1.28 0 0 1 2.55 0Z",
} as const;

export type SocialName = keyof typeof PATHS;

export function SocialIcon({
	name,
	className,
}: {
	name: SocialName;
	className?: string;
}) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="currentColor"
			aria-hidden="true"
			className={className}
		>
			<path d={PATHS[name]} />
		</svg>
	);
}
